export default __webpack_public_path__ + "static/media/bathroom1-after-768w.fe7868a5.webp";